<template>
  <v-menu offset-y v-bind:close-on-content-click="false" eager>
    <template v-slot:activator="{on}">
      <v-text-field label="Categories" v-on="on" hide-details readonly v-model="category.name" />
    </template>
    <v-card>
      <v-list>
        <template v-for="(item, index) in items">
          <v-list-item v-if="!item.item_tree" v-bind:key="index" v-on:click="change(item)">
            <v-list-item-content>
              <v-list-item-title>{{item.name}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-categories-list v-else v-bind:item="item" v-bind:key="index" v-bind:change="change"/>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  name: 'v-categories',
  data: () => ({
    category: {
      _id: 'top',
      name: 'Top'
    }
  }),
  props: {
    items: {type: Array, default: () => ([])},
    value: {type: Object, default: () => ({name: 'Top', _id: 'top'})},
  },
  methods: {
    change(item){
      this.category = this.$copy(item)
    },
    getCategory(){
      return this.category._id
    },
    setCategory(item){
      this.category.name = item.parent
      this.category._id = item.type
    }
  },
  watch: {
    category: {
      deep: true,
      handler(){
        this.$emit('value', this.category._id)
      }
    }
  },
  mounted(){
    if(this.value) this.category = this.value
  }
}
</script>
